import { useMemo } from 'react';

import useWindowSize from './useWindowSize';

export const useScreenSizeRatio = () => {
  const windowSize = useWindowSize();
  return useMemo(() => {
    if (!windowSize.height || !windowSize.width) return 1;

    if (windowSize.width > 2560) {
      // 4K ratio
      return 3840 / 1920;
    } else if (windowSize.width > 1920) {
      // 2K ratio
      return 2560 / 1920;
    } else if (windowSize.width > 1280) {
      // Full HD ratio
      return 1920 / 1920;
    } else if (windowSize.width > 960) {
      // Large ratio
      return 1280 / 1920;
    } else if (windowSize.width > 720) {
      // Medium
      return 1.1;
    } else if (windowSize.width > 500) {
      // Small
      return 0.8;
    }

    // Extra Small
    return 0.55;
  }, [windowSize.height, windowSize.width]);
};
